<div class="h-full flex flex-col overflow-hidden">
  <div class="flex gap-4 p-4 text-xl font-bold items-center">
    <wun-users-icon wunIcon/>
    {{user.value()?.data?.firstName}}
    {{user.value()?.data?.lastName}}
  </div>
  <div class="flex h-full overflow-hidden">
    @let showSidebar = userStateService.showSideBar();
    <div class="flex flex-col border  transition-all overflow-hidden" [class.h-0]="!showSidebar" [class.w-[220px]]="showSidebar" [class.w-0]="!showSidebar">
      <a class="w-full text-center font-bold text-black py-4 border" routerLinkActive="link-active"
         routerLink="/backoffice/users/artists">Artista</a>
      <a class="w-full text-center font-bold text-black py-4 border" routerLinkActive="link-active"
         routerLink="/backoffice/users/collectors">Collezionista</a>
      <a class="w-full text-center font-bold text-black py-4 border" routerLinkActive="link-active"
         routerLink="/backoffice/users/admins">Backoffice</a>
      <a class="w-full text-center font-bold text-black py-4 border" routerLinkActive="link-active"
         routerLink="/backoffice/users/gallery">Gallerie</a>
    </div>

    <div class="flex flex-col w-full overflow-hidden">
      @if (!showSidebar) {
        <div class="flex justify-between items-center  border-b-2">
          <div class="flex items-center">
            <a [routerLink]="['/','backoffice','users',id(), 'details', 'profile']" class="tab-link flex gap-3" [routerLinkActiveOptions]="{exact: true}" routerLinkActive="tab-link-active">
              <wun-profile-icon wunIcon/>
              Dettagli
            </a>
            <a  [routerLink]="['/','backoffice','users',id(), 'details','artworks']" class="tab-link" routerLinkActive="tab-link-active">
              Opere
            </a>
            <a  [routerLink]="['/','backoffice','users',id(), 'details','sales']" class="tab-link" routerLinkActive="tab-link-active">
              Vendite
            </a>
          </div>
          <div class="pr-4">
            @if (userStateService.navbarButtonState() === 'IDLE') {
              <button (click)="userStateService.navbarButtonState.set('EDIT')" wunButton primary>Modifica</button>
            } @else if (userStateService.navbarButtonState() === 'EDIT') {
              <button (click)="userStateService.navbarButtonClicked()" wunButton primary>Salva</button>
            }
          </div>
        </div>
      }
      <div class="flex-1 min-h-0 overflow-hidden">

        @defer (hydrate on idle) {
          <router-outlet/>
        }
      </div>
    </div>

  </div>
</div>
